module.exports = __webpack_public_path__ + "img/world.dde4dcf3.png";